// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { IFilterExpressionBuilder, ISchemaColumn } from '../../../../CommonScripts/Abstractions';

export class GeognosisFilterExpressionBuilder implements IFilterExpressionBuilder {
    private m_schemaColumn: ISchemaColumn;
    private m_schemaColumnName: string;
    private m_uid: string;

    createExpression(map) {
        let retVal = '';
        switch (this.m_schemaColumn.type) {
            // numbers               
            case 2: //Short int i2
            case 3: //long int i4 sis           
            case 4: //single r4
            case 5: //double r8 SIS #
            case 6: //currency
            case 14: //decimal
            case 18: //unsigned short int ui2
            case 19: //unsigned long int ui4
            case 20: //long long int i8
            case 21: //unsigned long long int ui8
                retVal = `${this.m_schemaColumn.expression}=${this.m_uid}`;
                break;
            //date
            case 7: //date
                const date = new Date(this.m_uid);
                if (isNaN(date.getTime())) {
                    break;
                }

                const pad = (num: number, size: number) => {
                    let s = String(num);
                    while (s.length < size) s = "0" + s;
                    return s;
                };

                const YYYY = date.getUTCFullYear();
                const MM = pad(date.getUTCMonth() + 1, 2);  // Months are 0-indexed
                const DD = pad(date.getUTCDate(), 2);
                const HH = pad(date.getUTCHours(), 2);
                const mm = pad(date.getUTCMinutes(), 2);
                const ss = pad(date.getUTCSeconds(), 2);
                const sss = pad(date.getUTCMilliseconds(), 3);

                retVal = `${this.m_schemaColumn.expression}='${YYYY}-${MM}-${DD}T${HH}:${mm}:${ss}.${sss}Z'`;
                break;
            //strings
            case 8: //string sis $
                retVal = `${this.m_schemaColumn.expression}='${this.m_uid}'`;
                break;
            //boolean types
            case 11: //boolean
                retVal = `${this.m_schemaColumn.expression}=${this.m_uid.toLowerCase}`;
                break;
        }
        return encodeURIComponent( retVal);
    }

    setExpressionData(schemaColumn: ISchemaColumn, uid: string) {
        this.m_schemaColumn = schemaColumn;
        this.m_schemaColumnName =schemaColumn.name;
        this.m_uid = uid;
    }
}

